.educationTextContainer {
  background: var(--selected-fill-10);
  border-radius: 10px;
  display: flex;
  padding: 15px;
  align-items: center;
  gap: 10px;
  width: 100%;
}

.resumeModalBody {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
  justify-content: space-between;
}

.radioGroup {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.radioOption {
  align-items: center;
  display: flex;
  gap: 2px;
}

.thisWeekOption,
.nextWeekOption {
  display: flex;
  gap: 10px;
}
